import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { ServiceCategoriesListWrapper } from './service-categories-list/ServiceCategoriesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const service_categoriesBreadcrumbs: Array<PageLink> = [
  {
    title: 'ServiceCategory Management',
    path: '/admin/pages/service-categories',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/service-categories/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const ServiceCategoryPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='service_categories'
          index
          element={
            <>
              <PageTitle breadcrumbs={service_categoriesBreadcrumbs}>ServiceCategories list</PageTitle>
              <ServiceCategoriesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/service-categories/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/service-categories' />} />
    </Routes>
  )
}

export default ServiceCategoryPage
